import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/tiffin-seva/donations";

export const Route = createFileRoute("/admin/tiffin-seva/donations")({
  component: Page,
});
